document.addEventListener('DOMContentLoaded', () => {
	const headings = document.querySelectorAll('.accordion-heading');

	headings.forEach(heading => {
		const content = document.getElementById(heading.dataset.accordion);

		heading.addEventListener('click', () => {
			const isOpen = heading.classList.contains('active');

			document.querySelectorAll('.accordion-heading').forEach(h => h.classList.remove('active'));
			document.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('open'));

			if (!isOpen) {
				heading.classList.add('active');
				content.classList.add('open');
			}
		});
	});

	// Ensure pre-opened accordions are styled correctly
	document.querySelectorAll('.accordion-heading.active').forEach(heading => {
		const content = document.getElementById(heading.dataset.accordion);
		content.classList.add('open');
	});
});
